import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  return (
    <header className="bg-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-6">
          <div className="flex-shrink-0">
            <Link to="/" className="text-2xl font-bold text-primary">
              Skepa
            </Link>
          </div>
          <nav className="hidden md:flex space-x-8">
            <Link to="/" className="text-secondary hover:text-primary transition duration-300">
              Home
            </Link>
            <Link to="/projects" className="text-secondary hover:text-primary transition duration-300">
              Projects
            </Link>
          </nav>
          <div className="md:hidden">
            <button className="text-secondary hover:text-primary">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
